<template>
  <p>Edit the Event Here.</p>
</template>

<script>
export default {
  props: ['event']
}
</script>
